import React from 'react';
import { useTranslation } from 'react-i18next';
import { Calculator } from 'lucide-react';
import { DataTable } from './UIComponents';
import { formatPrice, formatNumber, formatVolume } from './formatters';

const StockStatistics = ({ data }) => {
  const { t } = useTranslation();
  const keyStats = [
    { label: t('stocks.fields.marketCap'), value: formatNumber(data.marketCap, '$') },
    { label: t('stocks.fields.enterpriseValue'), value: formatNumber(data.marketCap && data.liabilities && data.currentAssets ? data.marketCap + data.liabilities - data.currentAssets : null, '$') },
    { label: t('stocks.fields.trailingPE'), value: data.peRatio ? data.peRatio.toFixed(2) : '--' },
    { label: t('stocks.fields.forwardPE'), value: '--' },
    { label: t('stocks.fields.pegRatio'), value: '--' },
    { label: t('stocks.fields.priceToSalesTtm'), value: data.priceToSales ? data.priceToSales.toFixed(2) : '--' },
    { label: t('stocks.fields.priceToBookMrq'), value: data.priceToBook ? data.priceToBook.toFixed(2) : '--' },
    { label: t('stocks.fields.enterpriseToRevenue'), value: '--' },
    { label: t('stocks.fields.enterpriseToEbitda'), value: '--' },
    { label: t('stocks.fields.sharesOutstanding'), value: formatNumber(data.sharesOutstanding) },
    { label: t('stocks.fields.float'), value: formatNumber(data.sharesOutstanding) },
    { label: t('stocks.fields.insiderOwnership'), value: '--' },
    { label: t('stocks.fields.institutionalOwnership'), value: '--' },
    { label: t('stocks.fields.shortRatio'), value: '--' },
    { label: t('stocks.fields.beta'), value: '--' },
    { label: t('stocks.fields.week52High'), value: formatPrice(data.weekHigh52) },
    { label: t('stocks.fields.week52Low'), value: formatPrice(data.weekLow52) },
    { label: t('stocks.fields.ma50Day'), value: '--' },
    { label: t('stocks.fields.ma200Day'), value: '--' },
    { label: t('stocks.fields.avgVolume3m'), value: formatVolume(data.avgVolume30) },
    { label: t('stocks.fields.dividendYield'), value: '--' },
    { label: t('stocks.fields.exDividendDate'), value: '--' },
  ];

  return (
    <div className="space-y-8">
      <DataTable
        title={t('stocks.tableTitles.keyStatistics')}
        icon={Calculator}
        data={keyStats}
        defaultExpanded={true}
      />
    </div>
  );
};

export default StockStatistics;